import {Box, Stack, Typography} from '@customink/pigment-react';
import PropTypes from 'prop-types';
import React from 'react';
import KeyBenefitItem from './KeyBenefitItem';

export default function KeyBenefits({keyBenefits}) {
  if (!keyBenefits.length) {
    return null;
  }
  return (
    <Stack gap="1rem">
      <Typography variant="h6">Key Benefits</Typography>
      <Box sx={{alignItems: 'stretch', display: 'flex', gap: '1rem'}}>
        {keyBenefits.map((keyBenefit) => (
          <KeyBenefitItem
            key={keyBenefit.title}
            description={keyBenefit.description}
            title={keyBenefit.title}
          />
        ))}
      </Box>
    </Stack>
  );
}

KeyBenefits.propTypes = {
  keyBenefits: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired
};
